export default __webpack_public_path__ + "static/SomethingWentWrongIcon-bb1a4e8a2ec6f7089591a53b03b3de83.svg";